import {Organisation} from "../../bo/organization/organisation";
import {Payement} from "../../bo/organization/payment";
import {Managerproperty} from "../../bo/admin/admin-user-form/managerproperty";
export class User {

  public id: any;
  public firstname: string = '';
  public lastname: string = '';
  public email: string ='';
  public password: string;
  public gender: number=0;
  public birthday: string;
  public phone: string;
  public avatar: string;
  public role_id: number=0;
  public organisation:Organisation;
  public payment:Payement;
  public logo:any;
  public manager:any;
  public managerproperty:Managerproperty  =new Managerproperty();
  public isOrga:boolean = false;
  public is_manager:boolean = false;
  public lang:string;
  public isPreAccount:boolean = false;
  public emailConfirm:string = '';
  public last_connection:string = '';


  constructor() {}


}
